module.exports = __webpack_public_path__ + "static/img/authentication2.b82d39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authentication2.png
// module id = nFi7
// module chunks = 1